module.exports = "<a v-if=\"template.media === 'print'\" target=_blank :href=downloadURL>{{ dataset.title}}</a><a v-else=v-else @click.prevent=openAs>{{ dataset.title }}</a>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/tables/cells/widget.vue
// module id = 474
// module chunks = 0